import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useClienteInfo() {
  const location = useLocation();
  const [clientInfo, setClientInfo] = useState({
    id: null,
    nombre: "",
    cedula: "",
    fecha: "",
    almacen: "",
    foto: "",
    NumeroSolicitud: "",
    vendedor: "",
    consulta: "",
    idEstadoVerificacionDocumental: "",
    idFirmaElectronica: "",
  });

  useEffect(() => {
    if (location.state) {
      localStorage.setItem("clientInfoBS", JSON.stringify(location.state));
      setClientInfo(location.state);
    } else {
      const saved = localStorage.getItem("clientInfoBS");
      if (saved) setClientInfo(JSON.parse(saved));
    }
  }, [location.state]);

  return clientInfo;
}
